import { HStack, Text, Icon, IconButton } from '@wegroup/design-system';
import StrokeBox from '@dashboard/src/components/common/StrokeBox';
import { FC } from 'react';

interface Props {
  title: string;
  href?: string;
}

export const InsurancePolicyDocument: FC<Props> = ({ title, href }) => {
  return (
    <StrokeBox py="3">
      <HStack spacing="2">
        <Icon name="GeneralOthersDocumentOrFile" color="primary.500" />
        <Text textStyle="normalBodyMedium" flexGrow="1">
          {title}
        </Text>
        <IconButton
          as={href ? 'a' : undefined}
          href={href}
          variant="white"
          isDisabled={!href}
          size="sm"
          aria-label="view"
          target="_blank"
          icon={<Icon name="GeneralActionsDownload" />}
        />
      </HStack>
    </StrokeBox>
  );
};
